import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Notifications.css';

export default function Notifications() {
  const [notes, setNotes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('jwt');
    if (!token) return;

    // fetch list
    fetch('/notifications', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json())
      .then(list => {
        setNotes(list || []);
      });
    // mark all read
    fetch('/notifications/markread', { method: 'PUT', headers: { Authorization: 'Bearer ' + token } })
      .then(() => {
        window.__notifCount = 0;
        window.dispatchEvent(new CustomEvent('notif-updated'));
      });
  }, []);

  const renderItem = (n) => {
    let text = '';
    switch (n.type) {
      case 'follow':
        text = `${n.from.name} started following you.`;
        break;
      case 'like':
        text = `${n.from.name} liked your post.`;
        break;
      case 'comment':
        text = `${n.from.name} commented: "${n.commentText}"`;
        break;
      case 'chat':
        text = `${n.from.name} sent you a message.`;
        break;
      case 'moment_comment':
        text = `${n.from.name} commented on your moment: "${n.commentText}"`;
        break;
      default:
        text = 'You have a notification.';
    }
    return (
      <div key={n._id} className={`notif-item ${n.read ? 'read' : ''}`}> 
        <img className="notif-avatar" src={n.from.Photo || '/logo192.png'} alt="" />
        <span className="notif-text">{text}</span>
      </div>
    );
  };

  return (
    <div className="notifications-page">
      <h2>Notifications</h2>
      {notes.length === 0 && <p>No notifications</p>}
      {notes.map(renderItem)}
    </div>
  );
}
